// /services/index.js
import feathers from '@feathersjs/feathers'
import socketio from '@feathersjs/socketio-client'
import io from 'socket.io-client'
import auth from '@feathersjs/authentication-client'
// import localStorage from 'localstorage-memory'

var serviceHost
if (process.env.NODE_ENV === 'production') {
  serviceHost = 'https://dashboard.intelisoft.ca:9003'
} else {
  serviceHost = 'http://localhost:9003'
}

const socket = io(serviceHost, {transports: ['websocket'], rejectUnauthorized: false})

export const app = feathers()
app.configure(socketio(socket))
   .configure(auth({ storage: window.localStorage }))

// repeat this line for every service in our backend
export const packinstalledService = app.service('packinstalled')
export const packService = app.service('pack')
export const containerService = app.service('container')
export const userService = app.service('users')
export const servicemonitoringService = app.service('servicemonitoring')

// in  actions.js, your component and anywhere else you need your services:
// import packinstalledService from './services';

// or load all services at once: import * as services from './services'
// and access them as services.packinstalledService etc.



// WEBPACK FOOTER //
// ./src/services/index.js